import { Card, Flex, Skeleton, Stack } from '@mantine/core';

const FeatureLimitTrackerLoader = () => {
    return (
        <Card w="100%" p="xs">
            <Flex h="100%" gap="lg" align="center">
                <Skeleton w={60} h={60} radius={99} style={{ flexShrink: 0 }} />

                <Stack align="flex-start" gap={8} w="100%">
                    <Skeleton w="100%" h={12} radius="xs" />
                    <Skeleton w={134} h={30} radius="xs" />
                </Stack>
            </Flex>
        </Card>
    );
};

export { FeatureLimitTrackerLoader };
